import cn from 'classnames';
import React from 'react';
import { DH } from '../../../../utils/DataHook';
import * as s from './styles.scss';
import { Theme } from '../../../../types/Theme';
import { DeviceType } from '../../../../types/DeviceType';

export interface PaymentMethodLayoutProps {
  dataHook?: string;
  noPadding?: boolean;
  theme: Theme;
  deviceType?: DeviceType;
}

export const PaymentMethodLayout: React.FunctionComponent<PaymentMethodLayoutProps> =
  (props) => {
    const {
      dataHook = DH.PaymentMethod.LayoutDefault,
      noPadding,
      theme,
      children,
      deviceType,
    } = props;

    return (
      <div
        data-hook={dataHook}
        className={cn(s.root, {
          [s.modalTheme]: theme === Theme.modal,
          [s.mobileTheme]: deviceType === 'mobile',
          [s.noPadding]: noPadding,
        })}
      >
        {children}
      </div>
    );
  };
PaymentMethodLayout.displayName = 'PaymentMethodLayout';
